import React, { useEffect, useState, useRef } from "react";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { useAppDispatch } from "../../../../../store";
import { useSelector } from "react-redux";
import * as styles from "../../../../../styles/WholedataPage";

import { LoadFarm, API_BASE_URL } from "../../../../../reduxaction/post";
import { RootState } from "../../../../../reducer/index";
import InsectLifeCycle from "../../component/InsectLifeCycle";
import DiaryDetailFormslice from "./DiaryDetailFormslice";
import axios from "axios";
import { isIdentifierStart } from "typescript";
import {
  Outersensors,
  Farmstype,
  diaryEquipTagstype,
} from "../../../../../reducer/postpayloadtypes";
import BeforeData from "./BeforeData";
import ImageModal from "./ImageModal";
import dayjs from "dayjs";
import "dayjs/locale/ko";
import { set } from "date-fns";
import { is } from "date-fns/locale";
dayjs.locale("ko");

const DiaryDetailForm = ({
  memo,
  postdate,
  AreaHandler,
  InputHandler,
  SelectHandler,
  age,
  setPutdata,
  putdata,
  setBodydata,
  getImage,
  setGetImage,
  imageSrc,
  setImageSrc,
  setUploadImage,
  uploadImage,
  deleteImage,
  setDeleteImage,
  deleteOccurImage,
  setDeleteOccurImage,
  uploadOccurImage,
  setUploadOccurImage,
  deleteDeathImage,
  setDeleteDeathImage,
  uploadDeathImage,
  setUploadDeathImage,
}: any) => {
  const dispatch = useAppDispatch();
  const { TargetDiary, Farms, Targetfarms } = useSelector(
    (state: RootState) => state.post
  );
  let [lifecycle, setLifecycle] = useState<any>(); // 곤충령기리스트
  let instar = TargetDiary?.diaryContents?.filter(
    (v: any) => v.diaryItem.name === "instar"
  );
  let productcode = TargetDiary?.diaryClass.productCode; // 곤충 productcode
  const diaryType = TargetDiary?.diaryClass.diaryType; // 작업 종류
  const diaryId = TargetDiary?.diaryId; // 일지 페이지 ID
  const DiaryDataLeftBox_ref = useRef<any>();
  let [height, setheight] = useState<any>();
  const [windowSize, setWindowSize] = useState(window.innerWidth);
  const [ImageTotal, setImageTotal] = useState(0);
  let [beforedata, setBeforedata] = useState<any>(null);
  let [modal, setModal] = useState<number>(0);
  let [calculation, setCalculation] = useState<any>();
  let [modalImage, setModalImage] = useState<any>();
  //상자 placeid 가져오기
  const boxes = TargetDiary?.places.filter((box) => box.type === "BOX");
  const boxplaceid = boxes?.[0].placeId;
  let [mainBeforeDId, setMainBeforeDId] = useState<string>("");
  let [beforeCnt, setBeforeCnt] = useState<number>(0);
  let [beforeDId, setBeforeDId] = useState<number>(0);

  const [nextDId, setNextDId] = useState<any[]>([]); // 전체 리스트
  const [isBtnDisable, setIsBtnDisable] = useState(false);

  useEffect(() => {
    dispatch(LoadFarm());
  }, []);
  if (modal !== 0) {
    document.body.style.overflow = "hidden";
  } else {
    document.body.style.overflow = "auto";
  }
  // useEffect(() => {
  //   let height_value = window.getComputedStyle(DiaryDataLeftBox_ref.current);
  //   setheight(height_value.height);
  //   console.log("현재높이", height)
  // }, []);

  const handleResize = () => {
    setWindowSize(window.innerWidth);
    let height_value = window.getComputedStyle(DiaryDataLeftBox_ref.current);
    setheight(height_value.height);
    // console.log("높이", heigdht..dd);
  };
  window.addEventListener("resize", handleResize);

  const ImageController = (fileBlob: any) => {
    const fileExtension = fileBlob.name.split(".").pop().toLowerCase();
    const supportedExtensions = ["jpg", "jpeg", "png"];

    if (!supportedExtensions.includes(fileExtension)) {
      // alert("This file type is not supported");
      // return;
      return confirmAlert({
        title: "확장자가 jpg, jpeg, png인 파일만 등록할 수 있습니다.",
        buttons: [
          {
            label: "Yes",
          },
        ],
      });
    }

    setUploadImage([...uploadImage, fileBlob]);
    if (imageSrc.length >= 10) {
      alert("이미지는 최대 10장까지 등록 가능합니다.");
    } else {
      const reader = new FileReader();
      reader.onload = () => {
        setImageSrc([...imageSrc, reader.result]);
      };
      reader.readAsDataURL(fileBlob);
    }
  };

  // const ImageController = (fileBlob: any) => {
  //   setUploadImage([...uploadImage, fileBlob]);
  //   if (imageSrc.length >= 10) {
  //     alert("이미지는 최대 10장까지 등록 가능합니다.");
  //   } else {
  //     const reader = new FileReader();
  //     reader.onload = () => {
  //       setImageSrc([...imageSrc, reader.result]);
  //     };
  //     reader.readAsDataURL(fileBlob);
  //   }
  // };
  useEffect(() => {
    //곤충령기
    axios
      .get(`/ifactory/api/lifecycle?productCode=${productcode}`)
      .then((res) => {
        setLifecycle(res.data);
      })
      .catch((error) => {
        console.log(error);
      });

    if (diaryId) {
      // 자동계산결과값 가져오기
      axios
        .get(`/ifactory/api/diarycontent/${diaryId}`)
        // .get(`/ifactory/api/diary/getDiaryCount/${diaryId}/${boxplaceid}`)

        .then((res) => {
          setCalculation(res.data);
        })
        .catch((error) => {
          console.log("err", error);
        });

      axios
        .get(
          `/ifactory/api/diary/past/${diaryId}/${TargetDiary?.manageBoxId}?diaryType=${diaryType}&productCode=${productcode}`
        )
        .then((res) => {
          setBeforedata(res.data);
          setMainBeforeDId(res.data.diaryId);
          setBeforeCnt(1);
        })
        .catch((error) => {
          console.log(error);
        });

      setNextDId([]);
      setNextDId([diaryId]);
      axios
        .get(
          `/ifactory/api/diary/past-ids/${diaryId}/${TargetDiary?.manageBoxId}?diaryType=${diaryType}&productCode=${productcode}&limit=5`
        )
        .then((res) => {
          res.data.map((item: any, idx: number) => {
            if (idx === 1) setBeforeDId(item);
            setNextDId((prev: any) => [...prev, item]);
          });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }, [TargetDiary, diaryId, diaryType, productcode]);

  //이전 데이터 환경정보 가져오기
  //외기 환경정보
  let [outersensors, setOutersensors] = useState<any>();
  //사육실 내부 환경 정보
  let [consensor, setConsensor] = useState<any>();

  // 사육상자 내부 환경 정보
  let [boxsensor, setBoxsensor] = useState<any>();

  useEffect(() => {
    // beforedata?.diaryEquips?.map((item: any, idx: number) => {
    // if (item?.equipName?.includes("외기")) {
    // setOutersensors(item?.diaryEquipTags);
    // } else if (item?.equipName?.includes("실내")) {
    // setConsensor(item?.diaryEquipTags);
    // } else if (item?.equipName?.includes("상자")) {
    // setBoxsensor(item?.diaryEquipTags);
    // }
    // setOutersensors(beforedata?.diaryEquips.dairyEquipFarm);
    // setConsensor(beforedata?.diaryEquipTags.diaryEquipBox);
    // setBoxsensor(beforedata?.diaryEquipTags.diaryEquipContainer);
    // });
  }, [beforedata]);

  const ImageHide = (e: any) => {
    if (e.name) {
      setDeleteImage([...deleteImage, e.name]);
    }
    getImage.map((Image: any, idx: any) => {
      setGetImage(getImage.filter((v: any) => v !== e));
    });
    imageSrc.map((Image: any, idx: any) => {
      setImageSrc(imageSrc.filter((v: any, i: number) => i !== idx));
      setUploadImage(uploadImage.filter((v: any, i: number) => i !== idx));
    });
  };

  const ImageModalItem = (Image: any) => {
    if (Image.name) {
      setModalImage(
        `${API_BASE_URL}/ifactroy/api/file/downloadfile/${Image.name}`
      );
    } else {
      setModalImage(Image);
    }
    setModal(2);
  };

  const beforedate = dayjs(beforedata?.tagStdDate).format(
    "YYYY년 MM월 DD일 dddd HH시 mm분"
  );

  const tagstartdate = dayjs(TargetDiary?.tagStdDate).format("YYYY-MM-DD");

  const tagstarttime = dayjs(TargetDiary?.tagStdDate).format("HH:mm");

  const cleanDatecovert = (data: any) => {
    // console.log("data:", data);
    if (
      data.diaryItem.name === "feedTime" ||
      data.diaryItem.name === "lastfeedTime"
    ) {
      if (data.value === "1") {
        return "O";
      } else if (data.value === "0") {
        return "X";
      }
    } else {
      return data.value;
    }
  };

  const viewBeForeData = (beDid: number, type: number) => {
    setIsBtnDisable(true);
    const newPlace = settingPlace(beDid);
    newPlace.then((res) => {
      setBeforedata(res);
      if (res.diaryId) {
        let cnt = type === 0 ? beforeCnt + 1 : beforeCnt - 1;
        setBeforeCnt(cnt);
        axios
          .get(
            `/ifactory/api/diary/past/${res.diaryId}/${TargetDiary?.manageBoxId}?diaryType=${diaryType}&productCode=${productcode}`
          )
          .then((res1) => {
            setBeforeDId(res1.data.diaryId);
            setIsBtnDisable(false);
          })
          .catch((error1) => {
            console.log(error1);
          });
      } else {
        setBeforeDId(0);
      }
    });
  };

  const settingPlace = async (placeId: number) => {
    return await axios
      .get(
        `/ifactory/api/diary/past/${placeId}/${TargetDiary?.manageBoxId}?diaryType=${diaryType}&productCode=${productcode}`
      )
      .then((res) => res.data)
      .catch((error) => {
        confirmAlert({
          title: error.response.data,
          buttons: [{ label: "Yes" }],
        });
      });
  };

  const renderDiaryForm = () => {
    const commonProps = {
      setPutdata,
      putdata,
      setBodydata,
    };

    switch (diaryType) {
      case "GROWTH":
        return <DiaryDetailFormslice.GROWTH {...commonProps} />;
      case "REPLACEFEED":
        return (
          <DiaryDetailFormslice.REPLACEFEED
            {...commonProps}
            calculation={calculation}
          />
        );
      case "CLEAN":
        return <DiaryDetailFormslice.CLEAN {...commonProps} />;
      case "FEED":
        return (
          <DiaryDetailFormslice.FEED
            {...commonProps}
            calculation={calculation}
          />
        );
      case "DISEASE":
        return (
          <DiaryDetailFormslice.DISEASE
            {...commonProps}
            deleteOccurImage={deleteOccurImage}
            setDeleteOccurImage={setDeleteOccurImage}
            uploadOccurImage={uploadOccurImage}
            setUploadOccurImage={setUploadOccurImage}
            deleteDeathImage={deleteDeathImage}
            setDeleteDeathImage={setDeleteDeathImage}
            uploadDeathImage={uploadDeathImage}
            setUploadDeathImage={setUploadDeathImage}
          />
        );
      default:
        return null;
    }
  };

  return (
    <styles.DiaryDetailFormContainer>
      <styles.DiaryDataContainer>
        <styles.DiaryDataLeftBox ref={DiaryDataLeftBox_ref}>
          <styles.DiaryDataLeftBoxTopItem>
            <div className="work-data-top">
              <p className="work-data-title">작업시간</p>
              <input
                type="date"
                name="startday"
                value={postdate.startday}
                // value={tagstartdate}
                onChange={InputHandler}
              />
              <input
                type="time"
                name="time"
                value={postdate.time}
                // value={tagstarttime}
                onChange={InputHandler}
              />
            </div>
          </styles.DiaryDataLeftBoxTopItem>

          <styles.DiaryDataLeftBoxTop>
            <styles.WorkItem>
              <div className="work-item-top">
                <p className="work-item-title">곤충령기</p>
              </div>
              <select value={age.value} onChange={SelectHandler}>
                {lifecycle &&
                  lifecycle.map((item: any, idx: any) => {
                    return (
                      <option key={item.lifeCycle} value={item.lifeCycle}>
                        {InsectLifeCycle(item.lifeCycle)}
                      </option>
                    );
                  })}
              </select>
            </styles.WorkItem>
            <styles.WorkItem>
              <div className="work-item-top">
                <p className="work-item-title">작업선택</p>
              </div>
              <input
                type="text"
                value={TargetDiary?.diaryClass.name}
                name="work"
              />
            </styles.WorkItem>
          </styles.DiaryDataLeftBoxTop>

          <styles.DiaryDataLeftBoxBot>
            {renderDiaryForm()}
          </styles.DiaryDataLeftBoxBot>
        </styles.DiaryDataLeftBox>

        <styles.DiaryDataRightBox style={{ height: `${height}` }}>
          {beforedata === "이전 데이터가 없습니다." ? (
            beforedata
          ) : (
            <>
              <p className="right-box-date">{beforedate}</p>
              <button
                onClick={() => {
                  setModal(1);
                }}
              >
                이전 환경정보 데이터
              </button>
              <p
                className="breeding-box-title"
                key={"history_" + diaryId + "_" + beforedata?.diaryId}
              >
                사육상자
              </p>

              <div className="breeding-box">
                {beforedata?.places.map((item: any, idx: number) => {
                  if (item.type === "BOX") {
                    return <p className="breeding-item">{item.name}</p>;
                  }
                })}
              </div>

              <div className="right-box-data">
                <p className="right-box-content">작업선택</p>
                <p className="right-box-value">
                  {beforedata?.diaryClass?.name}
                </p>
              </div>

              <p className="border-fff"></p>
              {beforedata?.diaryContents.map((item: any, idx: number) => {
                if (item.diaryItem.view === "Y") {
                  return (
                    <div className="right-box-data">
                      <p className="right-box-content">{item.diaryItem.note}</p>
                      <p className="right-box-value">{cleanDatecovert(item)}</p>
                    </div>
                  );
                }
              })}

              <div
                style={{
                  display: "inline-block",
                  width: "100%",
                  textAlign: "center",
                }}
              >
                {beforeDId && beforeCnt < 5 ? (
                  isBtnDisable ? (
                    <button
                      style={{
                        borderTop: "0.8em solid transparent",
                        borderBottom: "0.8em solid transparent",
                        borderRight: "1.6em solid green",
                        padding: "0px",
                        borderRadius: "0px",
                        backgroundColor: "unset",
                        cursor: "pointer",
                      }}
                    />
                  ) : (
                    <button
                      onClick={() => {
                        viewBeForeData(beforedata?.diaryId, 0);
                      }}
                      style={{
                        borderTop: "0.8em solid transparent",
                        borderBottom: "0.8em solid transparent",
                        borderRight: "1.6em solid green",
                        padding: "0px",
                        borderRadius: "0px",
                        backgroundColor: "unset",
                        cursor: "pointer",
                      }}
                    />
                  )
                ) : (
                  <button
                    style={{
                      borderTop: "0.8em solid transparent",
                      borderBottom: "0.8em solid transparent",
                      borderRight: "1.6em solid #f5f5f5",
                      padding: "0px",
                      borderRadius: "0px",
                      backgroundColor: "unset",
                    }}
                  />
                )}
                <div style={{ width: "5%", display: "inline-block" }}></div>
                {mainBeforeDId !== beforedata?.diaryId ? (
                  isBtnDisable ? (
                    <button
                      style={{
                        borderTop: "0.8em solid transparent",
                        borderBottom: "0.8em solid transparent",
                        borderLeft: "1.6em solid green",
                        padding: "0px",
                        borderRadius: "0px",
                        backgroundColor: "unset",
                        cursor: "pointer",
                      }}
                    />
                  ) : (
                    <button
                      onClick={() => {
                        viewBeForeData(nextDId[beforeCnt - 2], 1);
                      }}
                      style={{
                        borderTop: "0.8em solid transparent",
                        borderBottom: "0.8em solid transparent",
                        borderLeft: "1.6em solid green",
                        padding: "0px",
                        borderRadius: "0px",
                        backgroundColor: "unset",
                        cursor: "pointer",
                      }}
                    />
                  )
                ) : (
                  <button
                    style={{
                      borderTop: "0.8em solid transparent",
                      borderBottom: "0.8em solid transparent",
                      borderLeft: "1.6em solid #f5f5f5",
                      padding: "0px",
                      borderRadius: "0px",
                      backgroundColor: "unset",
                    }}
                  />
                )}
              </div>
            </>
          )}
        </styles.DiaryDataRightBox>
      </styles.DiaryDataContainer>

      <styles.Memo>
        {diaryType === "DISEASE" ? null : (
          <>
            <p className="content-tit">사진</p>
            <styles.ImageUpload>
              <label htmlFor="file">
                <div className="camera-btn">
                  <p className="camera-img">
                    <img src="./img/camera.svg" />
                  </p>
                  <p className="total-img">{ImageTotal}/10</p>
                </div>
              </label>
              <input
                type="file"
                id="file"
                accept="image/jpg, image/png, image/jpeg"
                onChange={(e: any) => ImageController(e.target.files[0])}
              />
              {imageSrc.map((Image: any, idx: any) => {
                return (
                  <styles.PreviewIamge>
                    <p
                      onClick={() => {
                        ImageHide(Image);
                      }}
                    >
                      <img src="./img/X.svg" />
                    </p>
                    <img
                      src={Image}
                      alt={idx}
                      onClick={() => {
                        ImageModalItem(Image);
                      }}
                    />
                  </styles.PreviewIamge>
                );
              })}
              {getImage?.map((Image: any, idx: any) => {
                return (
                  <styles.PreviewIamge>
                    <p
                      onClick={() => {
                        ImageHide(Image);
                      }}
                    >
                      <img src="./img/X.svg" />
                    </p>
                    <img
                      src={`${API_BASE_URL}/ifactroy/api/file/downloadfile/${Image.name}`}
                      onClick={() => {
                        ImageModalItem(Image);
                      }}
                      alt={idx}
                    />
                  </styles.PreviewIamge>
                );
              })}
            </styles.ImageUpload>
          </>
        )}

        <p className="content-tit mt-30">메모</p>
        <textarea onChange={AreaHandler} value={memo || ""}></textarea>
      </styles.Memo>

      {/* 이전 데이터 컴포넌트 */}
      {modal === 1 ? (
        <BeforeData
          modal={modal}
          filteredDiaryList={[beforedata]}
          setModal={setModal}
        />
      ) : null}
      {/* 이미지 모달 컴포넌트 */}
      {modal === 2 ? (
        <ImageModal modal={modal} setModal={setModal} modalImage={modalImage} />
      ) : null}
    </styles.DiaryDetailFormContainer>
  );
};

export default DiaryDetailForm;
